import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import { globalImportUrl } from '../core/request';
/**
 * Check user code for availabilty
 * Checks the availability of a user code for remote login
 * @param userCode User code for the remote login
 * @returns any Successful response
 * @throws ApiError
 */

export var checkRemoteLogin = function checkRemoteLogin(api, userCode) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/auth/remote_login";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof userCode !== 'undefined') {
    localVarQueryParameter['user_code'] = userCode;
  }

  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Remote login with device code
 * Remote login with device code
 * @param requestBody
 * @returns any Successful response
 * @throws ApiError
 */

export var remoteLogin = function remoteLogin(api, requestBody) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/auth/remote_login";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * User Authentication endpoint for Auth vendor
 * Validates the user by username or email, password used for external  Auth service. Return user id, and user information if authentication is valid. Segment analytics Login Event will be triggered by this endpoint
 * @param pelotonPlatform Platform the endpoint is called on. This may hide information from the response (class types, fitness disciplines, classes of certain fitness disciplines, etc.) that should not display on this platform. If this has any other effect on the endpoint, it will be noted in the description.
 *
 * @param pelotonClientDetails Client details that clients send to API for sending events to
 * Segment.
 *
 * These properties are sent as a mapping of key value pairs, where the
 * key is each expected Segment property name and its value is the client's
 * property value.
 *
 * Refer to
 * https://docs.google.com/spreadsheets/d/1NkMmgAqDERhzLJJ7E7gbgX2Mz8OBpSUOJ1n2xJS_2RI/edit#gid=1066590696
 * for more details on Segment events and schema.
 *
 * This mapping is first JSON-serialized and then base64-encoded. The
 * base64-encoding is set as the header's value.
 *
 * Below we outline some examples:
 *
 * Web Client
 * ~~~~
 * 'Browser': 'Chrome',
 * 'Form Factor': 'Desktop',
 * 'Operating System': 'Windows',
 * 'Screen Size': '1024x768',
 * 'Source': 'Member Search',
 * ~~~~
 *
 * Android Bike Client
 * ~~~~
 * 'Bike Frame Serial': 'T1710PL01059730',
 * 'OS Version': 11.3,
 * 'Touchscreen Generation': 'Ruby',
 * 'Touchscreen Serial': 'someSerialNumber',
 * 'Toggles': ['here_now', 'high_fives'],
 * 'Source': 'Profile'
 * ~~~~
 *
 * Android Tread Client
 * ~~~~
 * 'OS Version': 11.3
 * 'Touchscreen Generation': 'Ruby',
 * 'Touchscreen Serial': 'someSerialNumber',
 * 'MCB Serial': 'serialnumber',
 * 'Chassis Serial': 'serialnumber',
 * 'Smartcard Serial': 'serialnumber',
 * 'Toggles': ['here_now', 'high_fives'],
 * 'Source': 'Profile'
 * ~~~~
 *
 * iOS Client
 * ~~~~
 * 'Device Type': 'iPhone',
 * 'Device': 'iPhone X',
 * 'App Version': '8.6.0',
 * 'iOS Version': '10.0.2',
 * 'iOS Subscription ID': 'someIdNumber',
 * 'Source': 'Followers'
 * ~~~~
 *
 * @param requestBody
 * @returns any Successful response
 * @throws ApiError
 */

export var credentialsValidate = function credentialsValidate(api, pelotonPlatform, pelotonClientDetails, requestBody) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/auth/credentials/validate";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarHeaderParameter['Peloton-Platform'] = String(pelotonPlatform);
  localVarHeaderParameter['Peloton-Client-Details'] = String(pelotonClientDetails);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Answers an email verification challenge.
 * Answers an email verification challenge. The user corresponding to the email address being verified does not need to be authenticated.
 * @param requestBody
 * @returns any Successful response
 * @throws ApiError
 */

export var answerEmailVerificationChallenge = function answerEmailVerificationChallenge(api, requestBody) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/auth/email/answer_verification_challenge";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * User Authentication endpoint
 * Authenticate the user by username or email, password. Return session id, user id, pubnub session, and authenticated user information. Authenticated user information includes birthday, email, heart rate zones, subscriptions, etc.) Aurora content will be hidden unless aurora platform is specified in header. Segment analytics Login Event will be triggered by this endpoint
 * @param pelotonPlatform Platform the endpoint is called on. This may hide information from the response (class types, fitness disciplines, classes of certain fitness disciplines, etc.) that should not display on this platform. If this has any other effect on the endpoint, it will be noted in the description.
 *
 * @param pelotonClientDetails Client details that clients send to API for sending events to
 * Segment.
 *
 * These properties are sent as a mapping of key value pairs, where the
 * key is each expected Segment property name and its value is the client's
 * property value.
 *
 * Refer to
 * https://docs.google.com/spreadsheets/d/1NkMmgAqDERhzLJJ7E7gbgX2Mz8OBpSUOJ1n2xJS_2RI/edit#gid=1066590696
 * for more details on Segment events and schema.
 *
 * This mapping is first JSON-serialized and then base64-encoded. The
 * base64-encoding is set as the header's value.
 *
 * Below we outline some examples:
 *
 * Web Client
 * ~~~~
 * 'Browser': 'Chrome',
 * 'Form Factor': 'Desktop',
 * 'Operating System': 'Windows',
 * 'Screen Size': '1024x768',
 * 'Source': 'Member Search',
 * ~~~~
 *
 * Android Bike Client
 * ~~~~
 * 'Bike Frame Serial': 'T1710PL01059730',
 * 'OS Version': 11.3,
 * 'Touchscreen Generation': 'Ruby',
 * 'Touchscreen Serial': 'someSerialNumber',
 * 'Toggles': ['here_now', 'high_fives'],
 * 'Source': 'Profile'
 * ~~~~
 *
 * Android Tread Client
 * ~~~~
 * 'OS Version': 11.3
 * 'Touchscreen Generation': 'Ruby',
 * 'Touchscreen Serial': 'someSerialNumber',
 * 'MCB Serial': 'serialnumber',
 * 'Chassis Serial': 'serialnumber',
 * 'Smartcard Serial': 'serialnumber',
 * 'Toggles': ['here_now', 'high_fives'],
 * 'Source': 'Profile'
 * ~~~~
 *
 * iOS Client
 * ~~~~
 * 'Device Type': 'iPhone',
 * 'Device': 'iPhone X',
 * 'App Version': '8.6.0',
 * 'iOS Version': '10.0.2',
 * 'iOS Subscription ID': 'someIdNumber',
 * 'Source': 'Followers'
 * ~~~~
 *
 * @param requestBody
 * @returns any Successful response
 * @throws ApiError
 */

export var login = function login(api, pelotonPlatform, pelotonClientDetails, requestBody) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/auth/login";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarHeaderParameter['Peloton-Platform'] = String(pelotonPlatform);
  localVarHeaderParameter['Peloton-Client-Details'] = String(pelotonClientDetails);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Set forgotten password utilizing reset hash
 * Set forgotten password utilizing reset hash
 * @param resetHashId Identifier for reset hash id
 * @param requestBody
 * @returns any Successful response
 * @throws ApiError
 */

export var forgotPasswordResetHashId = function forgotPasswordResetHashId(api, resetHashId, requestBody) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var localVarPath = "/auth/forgot_password/".concat(resetHashId);
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Sends an email verification challenge.
 * Sends an email verification challenge to the logged in user's email address.
 * @returns any Successful response
 * @throws ApiError
 */

export var sendEmailVerificationChallenge = function sendEmailVerificationChallenge(api) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var localVarPath = "/auth/email/send_verification_challenge";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Check session status
 * Returns properties of the current session. If the current session is invalid or unauthenticated, the method does not throw an error. Instead it just returns with most values of the payload to Null
 * @returns any Successful response
 * @throws ApiError
 */

export var checkSession = function checkSession(api) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var localVarPath = "/auth/check_session";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * cancel a remote login via user_code or device_code
 * Expire a remote login via user_code or device_code
 * @param requestBody
 * @returns any No content
 * @throws ApiError
 */

export var remoteLoginCancel = function remoteLoginCancel(api, requestBody) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/auth/remote_login/cancel";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Authorizes a remote login
 * Authorize remote login
 * @param requestBody
 * @returns any Successfuly authozired remote login
 * @throws ApiError
 */

export var authorizeRemoteLogin = function authorizeRemoteLogin(api, requestBody) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/auth/remote_login/authorize";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Creates a new remote login
 * Create remote login
 * @param requestBody
 * @returns RemoteLogin Successful create response
 * @throws ApiError
 */

export var createRemoteLogin = function createRemoteLogin(api, requestBody) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/auth/remote_login/code";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Logout current user
 * Logout the user if a valid session exists otherwise return an error.
 * The method will return the session_id of the destroyed session.
 * @returns any Successful response
 * @throws ApiError
 */

export var logoutPost = function logoutPost(api) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var localVarPath = "/auth/logout";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Forgot password
 * forgot password
 * @param requestBody
 * @returns any Successful response
 * @throws ApiError
 */

export var forgotPassword = function forgotPassword(api, requestBody) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/auth/forgot_password";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * checks validity of reset hash
 * Check validity of reset hash by id.
 * @param resetHashId Identifier for reset hash id
 * @returns any Successful response
 * @throws ApiError
 */

export var validateResetHash = function validateResetHash(api, resetHashId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/auth/validate_reset_hash/".concat(resetHashId);
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Returns a session for a Publish/Subscriber service object
 * Returns a session for a Publish/Subscriber service object.
 * Currently the service provider is PubNub (https://www.pubnub.com/)
 * @returns PubSubSession a Publish/Subscriber session
 * @throws ApiError
 */

export var pubSubSession = function pubSubSession(api) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var localVarPath = "/auth/pubsub_session";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Change password
 * Change password
 * @param requestBody
 * @returns any Successful response
 * @throws ApiError
 */

export var changePassword = function changePassword(api, requestBody) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/auth/change_password";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Update user_code_state
 * Updates the state of a user code for remote login
 * @param requestBody
 * @returns any Successful response
 * @throws ApiError
 */

export var updateUserCodeState = function updateUserCodeState(api, requestBody) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/auth/remote_login/user_code/state";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'PUT'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Check user_code_state
 * Check what is the user_code_state of a remote login with device code
 * @param requestBody
 * @returns any Successful response
 * @throws ApiError
 */

export var checkUserCodeState = function checkUserCodeState(api, requestBody) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/auth/remote_login/user_code/state";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Check session status for use with the GraphQL Gateway authorization process
 * Almost identical to /auth/check_session, but avoids overfetching user data
 * @returns any Successful response
 * @throws ApiError
 */

export var getSession = function getSession(api) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var localVarPath = "/auth/session";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * exchange auth_token for a legacy session
 * return a legacy session id if auth_token present in request otherwise, return 401 Unauthorized
 * @returns any Successful response
 * @throws ApiError
 */

export var postSession = function postSession(api) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var localVarPath = "/auth/session";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Reactivate account via reset hash
 * Reactivate account via reset hash
 * @param resetHashId Identifier for reset hash id
 * @returns any Successful response
 * @throws ApiError
 */

export var reactivateAccountResetHashId = function reactivateAccountResetHashId(api, resetHashId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/auth/reactivate_account/".concat(resetHashId);
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};